import {useApolloClient, useMutation} from "@apollo/client";
import EventEmitter from "events";
import {useCallback, useEffect, useRef} from "react";
import {
    GetReactionsDocument, GetReactionsQueryResult,
    ReachTargetDocument,
    ReachTargetMutationResult,
    ReachTargetMutationVariables
} from "~/queries";


type Reactions = {[key: string]: any}

type ReachedTarget = {
    target: string
    params: any
}


const em = new EventEmitter();
const listeners = [];
let reactions: Reactions = {};
const reachedTargets: ReachedTarget[] = [];

export function getReactions() {
    return reactions;
}

export function addListener(listener: (reactions: Reactions) => void) {
    listeners.push(listener);
}

export function removeListener(listener: (reactions: Reactions) => void) {
    while (true) {
        const index = listeners.indexOf(listener);
        if (index != -1) {
            listeners.splice(index, 1);
        } else {
            break;
        }
    }
}

export function reachTarget(target: string, params: any) {
    reachedTargets.push({
        target: target,
        params: params
    });
    em.emit("send");
}



export function CustomerExperience(props) {
    const $promise = useRef<Promise<void>>(Promise.resolve());

    const [mutation] = useMutation<ReachTargetMutationResult, ReachTargetMutationVariables>(ReachTargetDocument, {
        onCompleted: (data) => {
            reachedTargets.splice(0, 1);
            reactions = data.reachTarget.reactions;
            for (const listener of listeners) {
                listener(reactions);
            }
        },
    });

    const client = useApolloClient();

    const handleSend = useCallback(() => {
        if (reachedTargets.length) {
            $promise.current = $promise.current.then(async () => {
                await mutation({
                    variables: {
                        params: reachedTargets[0].params,
                        target: reachedTargets[0].target,
                    }
                })
            }).catch(async e => {
                await new Promise(resolve => setTimeout(resolve, 5000));
            }).then(() => {
                handleSend();
            })

        }
    }, [mutation]);

    const initialize = useCallback(() => {
        $promise.current = $promise.current.then(async () => {
            const {data} = await client.query<GetReactionsQueryResult>({
                query: GetReactionsDocument,
                fetchPolicy: "network-only",
                notifyOnNetworkStatusChange: true,
            });
            reactions = data.reactions;
            for (const listener of listeners) {
                listener(reactions);
            }
        }).catch(async e => {
            await new Promise(resolve => setTimeout(resolve, 5000));
            initialize();
        });
    }, [])

    useEffect(() => {
        initialize();
    }, [])

    useEffect(() => {
        em.addListener("send", handleSend);

        return () => {
            em.removeListener("send", handleSend);
        }
    }, [handleSend]);

    return null;
}